import { TrendingUpRounded } from '@material-ui/icons';
import {
    INIT,
    RESET,
    SET_DIAS,
    SET_DISABLED,
    SET_TIPO_GESTION,
   
} from './types';

export const initialStateDisabled={
    "siniestro":{disabled:false, radio:true},
    "patente": {disabled:false, radio:true},
    "idcaso": {disabled:false, radio:true},
    "idcarpeta": {disabled:false, radio:true},
    "tipogestion": {disabled:false, radio:true},
    "estado": {disabled:false, radio:false}, 
    "situacion": {disabled:false, radio:false}, 
    "fechadesde": {disabled:false, radio:false},
    "fechahasta": {disabled:false, radio:false}, 
    "tipofecha": {disabled:false, radio:false}, 
    "audienciapendiente": {disabled:false, radio:false}, 
    "dias": {disabled:true, radio:false}, 
}

export default function buscarReducer(state , action) {
    switch (action.type) {
        case RESET:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},
                idcarpeta:{...state.idcarpeta, disabled:false},
                tipogestion:{...state.tipogestion, disabled:false},
                idcaso:{...state.idcaso, disabled:false},
                estado:{...state.estado, disabled:false},
                situacion:{...state.situacion, disabled:false},
                fechadesde:{...state.fechadesde, disabled:false},
                fechahasta:{...state.fechahasta, disabled:false},
                tipofecha:{...state.tipofecha, disabled:false},
                audienciapendiente:{...state.audienciapendiente, disabled:false},
                dias:{...state.dias, disabled:false},   
                }
        case INIT:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},
                idcarpeta:{...state.idcarpeta, disabled:false},
                tipogestion:{...state.tipogestion, disabled:false},
                idcaso:{...state.idcaso, disabled:false},
                estado:{...state.estado, disabled:true},
                situacion:{...state.situacion, disabled:true},
                fechadesde:{...state.fechadesde, disabled:true},
                fechahasta:{...state.fechahasta, disabled:true},
                tipofecha:{...state.tipofecha, disabled:true},
                audienciapendiente:{...state.audienciapendiente, disabled:true},
                dias:{...state.dias, disabled:false},              
                }
        case SET_DISABLED:
            action.payload.name

            return { ...state,[action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]} }
        
         case SET_TIPO_GESTION:
             return { ...state, [action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]},  estado:{...state.estado, disabled:true}, situacion:{...state.situacion, disabled:true}, audienciapendiente:{...state.audienciapendiente, disabled:true},}
        case SET_DIAS:
            return { ...state, dias:{...state.dias, disabled:action.payload}}
     
        
        
       
       
        default:
            return state
    }
}